<div [class.site]="!hiddenNavigateElement"
	 [class.show-submenu]="ifActiveSubmenuWorks || ifActiveSubmenuClients"
	 [class.show-search]="ifshowSearch">
	<header-app *ngIf="!hiddenNavigateElement"></header-app>
	<main class="site-content">
		<router-outlet (activate)="onActivate()"></router-outlet>
		<app-cookie-popup></app-cookie-popup>
	</main>
	<footer-app *ngIf="!hiddenNavigateElement"></footer-app>
</div>
<video-player #videoPlayer></video-player>
<preloader></preloader>
